"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _solarReact = require("@solar/solar-react");

var _core = require("@material-ui/core");

var _ChevronLeft = _interopRequireDefault(require("@material-ui/icons/ChevronLeft"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var snippets = ["\nage: {\n  description: 'Age in years',\n  type: 'integer',\n  minimum: 0,\n},\n", "\nname: {\n  description: 'name',\n  type: 'string',\n  required: true\n},\n"];
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      borderRight: "solid 1px ".concat(theme.palette.divider) // backgroundColor: theme.palette.background.paper,

    }
  };
});

var ButtonBar = function ButtonBar(_ref) {
  var classes = _ref.classes,
      onClickSnippet = _ref.onClickSnippet;
  var c = useStyles({
    classes: classes
  });
  return /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, {
    fullColumn: true,
    classes: {
      root: c.root
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    variant: "outlined",
    onClick: function onClick() {
      return onClickSnippet(snippets[0]);
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    variant: "outlined",
    onClick: function onClick() {
      return onClickSnippet(snippets[1]);
    }
  }, /*#__PURE__*/_react["default"].createElement(_ChevronLeft["default"], null)));
};

var _default = ButtonBar;
exports["default"] = _default;